import type { DeviceType } from '@carboncopyco/types';
import { ScreenBreakpoints } from '../consts/screen';

export const getScreenResolutionTypeFromWidth = (width: number): DeviceType => {
  if (width <= ScreenBreakpoints.mobile) {
    return 'mobile';
  }
  if (width <= ScreenBreakpoints.tablet) {
    return 'tablet';
  }

  return 'desktop';
};
